import { useTranslation } from "react-i18next";

function LegalPage({ tKey, testId }) {
  const { t } = useTranslation();
  const sections = t(`${tKey}.sections`, { returnObjects: true }) || [];
  return (
    <article className="anv-section" data-testid={testId}>
      <div className="anv-container max-w-4xl">
        <div className="anv-eyebrow">{t(`${tKey}.lastUpdated`)}</div>
        <h1 className="font-display mt-4 text-4xl md:text-5xl font-semibold text-[color:var(--anv-text)]">
          {t(`${tKey}.title`)}
        </h1>
        <p className="mt-6 text-[color:var(--anv-muted)] leading-relaxed">
          {t(`${tKey}.intro`)}
        </p>
        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${testId}-section-${i}`}>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-[color:var(--anv-ink)]">
                {s.heading}
              </h2>
              <p className="mt-3 text-[color:var(--anv-muted)] leading-relaxed">
                {s.body}
              </p>
            </section>
          ))}
        </div>
      </div>
    </article>
  );
}

export default LegalPage;
